import { formatRupiah } from 'helpers'
import React from 'react'
import { Card } from 'reactstrap'

const CardTrendingContainer = ({ title = '', amount = 0, lastIndex, index }) => {
  return (
    <Card style={{ marginRight : index !== lastIndex ? '10px': '', padding: '10px', borderRadius: '8px' }} className={'d-flex flex-fill'}>
        <label style={{ fontSize: '14px', fontWeight: 'lighter' }} className='text-center'>{title}</label>
        <label style={{ fontSize: '20px' }} className='text-center'>{amount}</label>
    </Card>
  )
}

export default CardTrendingContainer